import Validity from './Validity';
import Status from './Status';

export default Object.assign(
  {},
  {
    Validity,
    Status,
  },
);
